'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileName = exports.getOSName = exports.fileNameMapper = exports.osNameMapper = exports.getOSBit = undefined;

var _once2 = require('ramda/src/once');

var _once3 = _interopRequireDefault(_once2);

var _T2 = require('ramda/src/T');

var _T3 = _interopRequireDefault(_T2);

var _always2 = require('ramda/src/always');

var _always3 = _interopRequireDefault(_always2);

var _propEq2 = require('ramda/src/propEq');

var _propEq3 = _interopRequireDefault(_propEq2);

var _cond2 = require('ramda/src/cond');

var _cond3 = _interopRequireDefault(_cond2);

var _bowser = require('bowser');

var _bowser2 = _interopRequireDefault(_bowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAC = 'MAC';
/* global window */

var WINDOWS = 'Windows';
var DEFAULT_OS = WINDOWS;

// Detect 64-bit or 32-bit Windows from User Agent or Javascript? ref: https://goo.gl/bcsmpo
var getOSBit = exports.getOSBit = function getOSBit() {
  if (window.navigator.userAgent.indexOf('WOW64') !== -1 || window.navigator.userAgent.indexOf('Win64') !== -1) {
    return 64;
  }

  return 32;
};

var osNameMapper = exports.osNameMapper = (0, _cond3.default)([[(0, _propEq3.default)('mac', true), (0, _always3.default)(MAC)], [(0, _propEq3.default)('windows', true), (0, _always3.default)(WINDOWS)],
// [R.propEq('linux', true), R.always('Linux')],
[_T3.default, (0, _always3.default)(DEFAULT_OS)]]);

var fileNameMapper = exports.fileNameMapper = (0, _cond3.default)([[(0, _propEq3.default)('mac', true), (0, _always3.default)('osx64.tar.gz')], [(0, _propEq3.default)('windows', true), (0, _always3.default)('win' + getOSBit() + '.zip')],
// [R.propEq('linux', true), R.always('Linux')],
[_T3.default, (0, _always3.default)('win64.zip')]]);

var getOSName = exports.getOSName = (0, _once3.default)(function () {
  return osNameMapper(_bowser2.default);
});
var getFileName = exports.getFileName = (0, _once3.default)(function () {
  return fileNameMapper(_bowser2.default);
});


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/utils/osHelper.js
// module id = 352
// module chunks = 4